import Vue from 'vue'

const state = {
  users: [],
  roles: []
}

const mutations = {
  SET_USERS ({ commit }, value) {
    state.users = value || []
  },
  SET_ROLES ({ commit }, value) {
    state.roles = value
  },
  ADD_USER ({ commit }, value) {
    state.users.push(value)
  },
  DELETE_USER ({ commit }, user) {
    state.users.splice(state.users.indexOf(user), 1)
  },
  UPDATE_USER ({ commit }, user) {
    // TODO: Improve the following:
    // Maybe we just might do u = user but first we might need to check how the data from the API looks like
    for (let u of state.users) {
      if (u.ID === user.ID) {
        // u = user --> This didn't work for some reason. It was only updating any int value but not the strings such as "Name" properties.
        // For some other reason, values for FirstName, LastName and Email are automatically updating.
        // I believe it must have something with the binding - since we are binding only the ID's in our dropdowns.
        u.Location.ID = user.Location.ID
        u.Location.Name = user.Location.Name
        u.Roles[0].Name = user.Roles[0].Name
        u.Roles[0].ID = user.Roles[0].ID
        break
      }
    }
  }
}

const actions = {
  getUsers ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}users/getbylocation`)
        .then(response => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getRoles ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.axios.get(`${window.config.apiUrl}users/getroles`)
        .then(response => {
          commit('SET_ROLES', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createUser ({ commit }, user) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}users/create`, user)
        .then(response => {
          if (response.data !== '') {
            commit('ADD_USER', response.data)
            resolve(response)
          } else {
            reject(new Error('User already exists.'))
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateUser ({ commit }, user) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}users/update`, user)
        .then(response => {
          if (response.data !== -1) {
            commit('UPDATE_USER', response.data)
          } else {
            reject(new Error(`The email address is already being used by another user.`))
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  deleteUser ({ commit }, user) {
    return new Promise((resolve, reject) => {
      Vue.axios.post(`${window.config.apiUrl}users/delete`, user)
        .then(response => {
          if (response.data) {
            commit('DELETE_USER', user)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}

const getters = {
  users () {
    return state.users
  },
  roles () {
    return state.roles
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js